/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { makeSelectPageNewsTranslation } from '@/main/modules/internationalization/intSelectors';

import { ECreateNewsTypes } from '../../../constants';

export const useActionModalTranslation = (type: ECreateNewsTypes) => {
    const isExternal = type === ECreateNewsTypes.EXTERNAL;
    const {
        modals: {
            publishModals: { createExternalNewsModal: tExternalModal, createInternalNewsModal: tInternalModal },
        },
    } = useSelector(makeSelectPageNewsTranslation());

    return useMemo(
        () => ({
            title: isExternal ? tExternalModal.title : tInternalModal.title,
            start: isExternal ? tExternalModal.start : tInternalModal.start,
            success: isExternal ? tExternalModal.success : tInternalModal.success,
            error: isExternal ? tExternalModal.error : tInternalModal.error,
        }),

        // translation deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isExternal],
    );
};
